 import React, { useEffect, useState } from "react";
import "../ConfirmOrdersDetails/ConfirmOrdersDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import emptyorders from "../../assets/empty-cart.png";
import { BaseUrl } from "../../App";

export default function ConfirmedOrdersDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const orderId = id;

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);

  const orderInfo = order?.order;
  const userInfo = order?.user;
  const items = order?.items || [];
  const currentStatus = orderInfo?.status;

  /* ================= CHANGE STATUS ================= */
//   const handleStatusChange = async () => {
    
//     if (!orderInfo) return;

//     try {
     
// await axios.post(
//   `${BaseUrl}admin/update-status-order/${orderInfo.order_id}`,
//   {
//     status:
//       currentStatus === "processing"
//         ? "shipping"
//         : "completed",
//   },
//   {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//       Accept: "application/json",
//     },
//   }
// );
//       setShowConfirm(false);

//       // رجوع لصفحة الطلبات عشان يحصل refresh للقائمة
//       navigate("/confirmedorders");

//     } catch (err) {
//       console.log(err);
//     }
//   };
const handleStatusChange = async () => {

  if (!orderInfo) return;

  try {

    let nextStatus = "";

    if (currentStatus === "pending") {
      nextStatus = "processing";
    } 
    else if (currentStatus === "processing") {
      nextStatus = "shipping";
    } 
    else if (currentStatus === "shipping") {
      nextStatus = "completed";
    }

    await axios.post(
      `${BaseUrl}admin/update-status-order/${orderInfo.order_id}`,
      {
        status: nextStatus
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    setShowConfirm(false);
    navigate("/confirmedorders");

  } catch (err) {
    console.log(err);
  }
};
  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${BaseUrl}${BuyerServicesUrl.OrderDetails}/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token"
              )}`,
              Accept: "application/json",
            },
          }
        );

        setOrder(res.data?.data || null);
      } catch (err) {
        console.log(err);
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) fetchOrderDetails();
  }, [orderId]);

  if (loading) {
    return (
      <div className="orders-loader text-center py-5 mt-5">
        <div className="loader-circle mb-3"></div>
        <p className="fw-bold">جاري تحميل التفاصيل...</p>
      </div>
    );
  }

  if (!order || !orderInfo) {
    return (
      <div className="noorders text-center mt-5">
        <img src={emptyorders} alt="no-data" />
        <h4 className="mt-4">لا توجد بيانات لهذا الطلب</h4>
        <button
          className="order-btn mt-3"
          onClick={() => navigate("/confirmedorders")}
        >
          الرجوع للطلبات
        </button>
      </div>
    );
  }

  return (
    <div
      className="container order-page pt-5"
      style={{ marginTop: "12%", marginBottom: "22%" }}
    >
      {/* USER */}
      {/* <div className="card-box mb-4 user-card">
        <div className="avatar-circle mb-3">
          <i className="fa-solid fa-user m-auto"></i>
        </div>
        <div>
          <h5 className="fw-bold">{userInfo?.name}</h5>
          <p className="small-text">{userInfo?.phone}</p>
          <p className="small-text">{userInfo?.email}</p>
          <p className="small-text">{userInfo?.country}</p>
        </div>
      </div> */}

      {/* PRODUCTS */}
      <div className="coproduct-details">
        <h6 className="fw-bold mb-3 pro-de">تفاصيل المنتج</h6>

        {items.map((item) => (
          <div className="card-box mb-3" key={item.item_id}>
            <div className="product-wrapper-new position-relative w-100">
              <div className="side-lock-codetails">
                <i className="fa fa-lock colockicon"></i>
              </div>

              <div className="coproduct-info">
                <h6 className="fw-bold mb-1 co-title">{item.item_name}</h6>

                <p className="small-text mb-2">
                  {item.description?.length > 150
                    ? item.description.slice(0, 150) + "..."
                    : item.description}
                </p>

                <div className="discount-price-row">
                  <div className="discount-row">
                    <span className="qty-badge">
                      x{item.quantity}
                    </span>
                    <span className="discount-text">
                      خصم {item.discount} %
                    </span>
                  </div>

                  <div className="price-text">
                    {item.total} ر.س
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        <hr className="codetails-line" />

        {/* SUMMARY */}
        <div className="card-box summary-card mt-3 mb-5">
          {/* <div className="cosummary-row">
            <span>العدد :</span>
            <span>{orderInfo.count_items}</span>
          </div> */}

          <div className="cosummary-row d-flex">
            <span>السعر :</span>
            <span>{orderInfo.total} ر.س</span>
          </div>

          <div className="cosummary-row">
            <span>مصاريف الشحن :</span>
            <span>{orderInfo.fees} ر.س</span>
          </div>

          {/* <div className="cosummary-row">
            <span>طريقة الدفع :</span>
            <span>
              {orderInfo.payment_type === "visa"
                ? "فيزا"
                : orderInfo.payment_type}
            </span>
          </div> */}

          <div className="cosummary-row total-row">
            <span>الإجمالي</span>
            <span>{orderInfo.final_total} ر.س</span>
          </div>
        </div>

        {/* STATUS */}
        {/* <div className="order-status-card">
          <div className="status-row">
            <span className="status-title">حالة الطلب</span>
            <span className="status-text">
              {currentStatus === "processing"
                ? "جاري المعالجة"
                : currentStatus === "shipping"
                ? "تم الشحن"
                : currentStatus === "completed"
                ? "تم التسليم"
                : currentStatus === "cancelled"
                ? "ملغي"
                : ""}
            </span>
          </div>
        </div> */}
<div className="order-status-card">
  <div className="status-row">
    <span className="status-title">حالة الطلب</span>

    <span className="status-text">
      {currentStatus === "pending"
        ? "قيد الانتظار"
        : currentStatus === "processing"
        ? "جاري المعالجة"
        : currentStatus === "shipping"
        ? "تم الشحن"
        : currentStatus === "completed"
        ? "تم التسليم"
        : currentStatus === "cancelled"
        ? "ملغي"
        : currentStatus}
    </span>

  </div>
</div>
        {/* ACTION BUTTON */}
        {/* {
        (currentStatus === "processing" ||
          currentStatus === "shipping") && (
          <button
            className="shipment-btn"
            onClick={() => setShowConfirm(true)}
          >
            {currentStatus === "processing"
              ? "تم الشحن"
              : "تم التوصيل"}
          </button>
        )} */}

{(currentStatus === "pending" ||
  currentStatus === "processing" ||
  currentStatus === "shipping") && (
  <button
    className="shipment-btn"
    onClick={() => setShowConfirm(true)}
  >
    {currentStatus === "pending"
      ? "بدء المعالجة"
      : currentStatus === "processing"
      ? "تم الشحن"
      : "تم التوصيل"}
  </button>
)}
        {/* CONFIRM MODAL */}
        {showConfirm && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <h5 className="confirm-title">تأكيد</h5>

              <p className="confirm-text">
                هل أنت متأكد من تنفيذ هذه العملية؟
              </p>

              <div className="confirm-buttons">
                <button
                  className="confirm-btn"
                  onClick={handleStatusChange}
                >
                  نعم
                </button>

                <button
                  className="cancel-btn"
                  onClick={() => setShowConfirm(false)}
                >
                  لا
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}